// components/EventChip.tsx
import React from "react";
import { Chip } from "@mui/material";

interface EventChipProps {
  eventType?: string;
  otherEventName?: string;
}

const EVENT_COLOR_MAP: Record<string, { bg: string; color: string }> = {
  wedding: {
    bg: "#00B894",
    color: "#ffffff",
  },
  birthday: {
    bg: "#9B59B6",
    color: "#ffffff",
  },
  reception: {
    bg: "#0984E3",
    color: "#ffffff",
  },
  "ring ceremony": {
    bg: "#E84393",
    color: "#ffffff",
  },
  other: {
    bg: "#6AB04C",
    color: "#ffffff",
  },
};

export const getEventColor = (eventType?: string): string => {
  if (!eventType) return "#E0E0E0";
  const normalizedType = eventType.trim().toLowerCase();
  return EVENT_COLOR_MAP[normalizedType]?.bg ?? "#E0E0E0";
};

export const EventChip: React.FC<EventChipProps> = ({
  eventType,
  otherEventName,
}) => {
  if (!eventType) return null;

  const normalizedType = eventType.trim().toLowerCase();

  const isOtherSocial = normalizedType === "other social";

  const label = isOtherSocial
    ? `${eventType}${otherEventName ? ` (${otherEventName})` : ""}`
    : eventType;

  const colorConfig = EVENT_COLOR_MAP[normalizedType] ?? {
    bg: "#E0E0E0",
    color: "#424242",
  };

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: colorConfig.bg,
        color: colorConfig.color,
        fontWeight: 600,
        textTransform: "uppercase",
        borderRadius: "16px",
        px: 1.2,
      }}
    />
  );
};




const SOURCE_COLOR_MAP: Record<string, { bg: string; color: string }> = {
  meta: {
    bg: "#00B894",
    color: "#ffffff",
  },
  instagram: {
    bg: "#9B59B6",
    color: "#ffffff",
  },
  reception: {
    bg: "#0984E3",
    color: "#ffffff",
  },
  direct: {
    bg: "#E84393",
    color: "#ffffff",
  },
  googlesheet: {
    bg: "#6AB04C",
    color: "#ffffff",
  },
};

export const SourceEventChip: React.FC<EventChipProps> = ({
  eventType,
  otherEventName,
}) => {
  if (!eventType) return null;

  const normalizedType = eventType.trim().replaceAll(" ", "").toLowerCase();

  const isOtherSocial = normalizedType === "other social";

  const label = isOtherSocial
    ? `${eventType}${otherEventName ? ` (${otherEventName})` : ""}`
    : eventType;

  const colorConfig = SOURCE_COLOR_MAP[normalizedType] ?? {
    bg: "#E0E0E0",
    color: "#424242",
  };

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: colorConfig.bg,
        color: colorConfig.color,
        fontWeight: 600,
        textTransform: "uppercase",
        borderRadius: "16px",
        px: 1.2,
      }}
    />
  );
};